import React, { useState } from "react";
import * as Icon from "react-bootstrap-icons";
import { useSelector } from "react-redux";

const AddressItem = ({ address }) => {
  const [isVisible, setIsVisible] = useState(false);
  const lang = useSelector((state) => state.mainSlice.lang);

  return (
    <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-3">
      <div className="address-item">
        <div className="address-item-inner">
          <div className="info-wrapper">
            <h6>
              {lang === "en"
                ? address.name_en
                : lang === "ru"
                ? address.name_ru
                : address.name_tm}
            </h6>
            <p>
              {lang === "en"
                ? address.address_en
                : lang === "ru"
                ? address.address_ru
                : address.address_tm}
              <br />
              {lang === "en"
                ? address.phone_en
                : lang === "ru"
                ? address.phone_ru
                : address.phone_tm}
            </p>
            <span>
              <Icon.Envelope /> {address.email}
            </span>
          </div>
          <div
            className="map-wrapper"
            onClick={() => {
              setIsVisible(!isVisible);
            }}
          >
            <img
              src={process.env.REACT_APP_API_URL + address.map_image}
              alt="Map"
              width="100%"
            />
          </div>
        </div>
      </div>
      <div className={`hidden-map ${isVisible ? "d-block" : ""}`}>
        <div className="map-inner-wrapper">
          <div className="map-border">
            <iframe
              title={address.id}
              src={address.map_string}
              width="100%"
              height="600"
              frameBorder="0"
            ></iframe>
          </div>
          <div
            className="icon-wrapper"
            onClick={() => {
              setIsVisible(!isVisible);
            }}
          >
            <Icon.X />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddressItem;
